import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { FormRenderer } from './FormRenderer';

/**
 * Builder-side preview wrapper. Reuses the same FormRenderer used by the
 * candidate page so what the recruiter sees IS what the candidate gets.
 */
export const FormPreviewPane = ({ form, open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto" data-testid="form-preview-dialog">
        <DialogHeader>
          <DialogTitle>Preview · {form.name}</DialogTitle>
          <DialogDescription>How candidates will see and complete this form.</DialogDescription>
        </DialogHeader>
        <div className="border border-border rounded-xl bg-slate-50 p-6">
          <FormRenderer form={form} readOnly />
        </div>
      </DialogContent>
    </Dialog>
  );
};
